import { Filesystem, Directory, Encoding, ReaddirResult } from '@capacitor/filesystem'
import logError from '../../consts/log-error'

// async function checkIfExists ({ dir = '', name }: CheckIfExistsProps): Promise<boolean> {
//   return await readDir(dir).then(result => result.files.some(f => f.name === name))
// }

async function createDir (name: string, parents = ''): Promise<void> {
  try {
    return await Filesystem.mkdir({
      directory: Directory.Data,
      path: `${parents}${parents === '' ? '' : '/'}${name}`,
      recursive: true // Crear directorios padre recursivamente
    })
  } catch (error) {
    // Ignorar error si el directorio ya existe
    if (!error.message?.includes('already exists')) {
      throw error
    }
  }
}

async function readDir (name = ''): Promise<ReaddirResult> {
  return await Filesystem.readdir({
    directory: Directory.Data,
    path: name
  }).catch(err => { logError(err); return { files: [] } })
}

async function readFile (name: string): Promise<string> {
  return await Filesystem.readFile({
    directory: Directory.Data,
    encoding: Encoding.UTF8,
    path: name
  }).then(resp => resp.data as string)
    .catch(err => { logError(err + name); return '' })
}

async function writeFile (name: string, data: string, retries = 1): Promise<void> {
  try {
    await Filesystem.writeFile({
      data,
      directory: Directory.Data,
      encoding: Encoding.UTF8,
      path: name,
      recursive: true
    })
  } catch (error) {
    if (retries > 0) {
      await new Promise(resolve => setTimeout(resolve, 500))
      return await writeFile(name, data, retries - 1)
    }
    throw error
  }
}

async function writeBlob (name: string, data: Blob): Promise<void> {
  return await new Promise(resolve => {
    const fr = new FileReader()
    fr.onload = async data =>
      // await writeFile(name, (data.target?.result as string).split(';base64,')[1])
      await writeFile(name, (data.target?.result as string))
        .then(() => resolve())
    fr.readAsDataURL(data)
  })
}

async function removeDir (name: string): Promise<void> {
  return await Filesystem.rmdir({
    directory: Directory.Data,
    path: name,
    recursive: true
  })
}

async function removeFile (name: string): Promise<void> {
  return await Filesystem.deleteFile({
    directory: Directory.Data,
    path: name
  })
}

export {
  createDir,
  readDir,
  readFile,
  removeDir,
  writeBlob,
  writeFile,
  removeFile
}
